/**
 * SidebarGroup — collapsible nav group used by StudioShell (and historically
 * by WebStudioPage directly). Extracted in Sprint 1070.C3 so other studios
 * can consume it via the shared StudioShell wrapper.
 */
import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export default function SidebarGroup({ id, label, Icon, items, defaultOpen, active, onPick, activeGroup }) {
  const [open, setOpen] = useState(defaultOpen);
  const isActiveGroup = activeGroup === id;
  return (
    <div className="mt-3" data-testid={`web-studio-group-${id}`} data-active-group={isActiveGroup || undefined}>
      <button
        onClick={() => setOpen((o) => !o)}
        className={`w-full flex items-center justify-between px-3 py-1.5 text-[10px] tracking-[0.18em] uppercase font-semibold transition-colors ${
          isActiveGroup
            ? "text-sky-300 dark:text-sky-300"
            : "text-[var(--app-text-muted)] hover:text-[var(--app-text)]"
        }`}
      >
        <span className="flex items-center gap-2">
          {Icon ? <Icon className="w-3.5 h-3.5" /> : null}
          {label}
        </span>
        {open ? <ChevronDown className="w-3 h-3" /> : <ChevronRight className="w-3 h-3" />}
      </button>
      {open && (
        <div className="mt-1">
          {items.map((item) => {
            const ItemIcon = item.icon;
            const isActive = active === item.key;
            // Sprint 1070.C5-prep6 — "You are here" tooltip for highlighted
            // sidebar items: section name + mission stage badge.
            const tooltip = isActive
              ? `📍 You are here · ${item.label} · Mission stage: ${label}`
              : item.label;
            return (
              <button
                key={item.key}
                onClick={() => onPick(item)}
                data-testid={`web-studio-nav-${item.key}`}
                data-active={isActive || undefined}
                data-you-are-here={isActive ? tooltip : undefined}
                title={tooltip}
                className={`w-full flex items-center gap-2 px-3 py-1.5 rounded-md text-xs transition-colors ${
                  isActive
                    ? "bg-sky-500/15 text-sky-300 font-semibold border-l-2 border-sky-400"
                    : "text-[var(--app-text-secondary)] hover:bg-[var(--app-surface-hover)] hover:text-[var(--app-text)]"
                }`}
                style={{ paddingLeft: isActive ? "28px" : "30px" }}
              >
                {ItemIcon ? <ItemIcon className="w-3.5 h-3.5" /> : null}
                <span className="truncate">{item.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
